import { useSelector } from 'react-redux'

export const useMetabaseCheck = () => {
	const { company } = useSelector(({ session }) => session)

	return {
		hasMetabase: !!company.metabase_dashboard_id,
		dashboardId: company.metabase_dashboard_id,
	}
}
